import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import './AyaSelector.css';
import { AutoComplete, TextField } from 'material-ui';
import Quran from '../../quran/Quran';
import { toEnglishDigits } from "../../utils";
import QuranData from '../../quran/quran-data';

const suras = Quran.suras.map((sura, i) => ({
  text: sura.number + ' - ' + sura.pname,
  value: sura.number
}))
suras.pop()
suras.shift()

class AyaSelector extends Component {

  constructor(props) {
    super(props)
    this.state = {
      suraField: 'فاتحه',
      ayaField: '1',
      matchedSura: 0,
      prevGeneralAya: 0
    }
  }

  componentDidMount() {
    window.requestAnimationFrame(this.handleChanges)
    this.updateState()
  }

  updateState() {
    if (this.props.generalAya == null) return
    const {suraNumber, ayaNumber, suraName} = Quran.getSuraAndAya(this.props.generalAya)
    this.setState({
      suraField: suraName,
      ayaField: String(ayaNumber),
      matchedSura: suraNumber,
      prevGeneralAya: this.props.generalAya  
    })
  }

  filterFunction(searchText, key) {
    searchText = toEnglishDigits(searchText)
    if (AutoComplete.fuzzyFilter(searchText, key)) return true
    else return false
  }

  handleSuraChange = (newValue) => {
    console.log('input changed')
    this.setState({suraField: newValue})

    const exactMatch = suras.filter(sura => sura.text === newValue || ~sura.text.split(' - ').indexOf(newValue))[0]
    if (exactMatch) {
      this.setState(() => {
        window.requestAnimationFrame(this.handleChanges)
        return {matchedSura: exactMatch.value}
      })
    } else {
      const matchedArray = suras.filter(sura => AutoComplete.fuzzyFilter(newValue, sura.text))
      this.setState(() => {
        window.requestAnimationFrame(this.handleChanges)
        return {matchedSura: (matchedArray[0] && matchedArray[0].value) || 0}
      })
    }

    this.handleChanges()
  }

  handleAyaChange = (event, newValue) => {
    console.log(newValue)
    newValue = toEnglishDigits(newValue)
    if (newValue === '') return this.setState({ayaField: ''})
    if (newValue <= 0) return
    // newValue = Math.min(newValue, QuranData.Sura[this.state.matchedSura][1])
    this.setState(() => {
      window.requestAnimationFrame(this.handleChanges)
      return {ayaField: newValue}
    })
  }

  handleChanges = () => {
    if (typeof this.props.onChanged !== 'function') return
    const globalAya = Quran.getGlobalAyaNumber(+this.state.matchedSura, +this.state.ayaField)
    this.props.onChanged(globalAya)
  }

  render() {

    if (this.state.prevGeneralAya !== this.props.generalAya) {
      requestAnimationFrame(this.updateState.bind(this))
    }

    const paperStyles = {
      margin: '1.6em 1em',
      padding: '0.8em',
    }

    const suraFieldStyles = {
      width: '90px',
      fontWeight: 'bold',
      backgroundColor: '#efefef',
      textAlign: 'center',
      borderRadius: '0.16em'
    }
    const ayaFieldStyles = {
      width: '50px',
      fontWeight: 'bold',
      backgroundColor: '#efefef',
      textAlign: 'center',
      borderRadius: '0.16em',
      direction: 'rtl'
    }

    const matchedSuraListStyles = {
      width: 'auto',
      minWidth: '150px',
      maxHeight: '400px',
    }

    return (
        <div className="aya-selector">
          <Paper zDepth={2} style={paperStyles}>
            <div className="aya-selector__title">{this.props.title}</div>
            <div className="aya-selector__sura-box">
              <div className="aya-selector__sura-caption">سوره‌ی</div>
              <div className="aya-selector__sura">
                <AutoComplete
                  // filter={AutoComplete.fuzzyFilter}
                  openOnFocus={true}
                  dataSource={suras}
                  textFieldStyle={suraFieldStyles}
                  listStyle={matchedSuraListStyles}
                  filter={this.filterFunction}
                  searchText={this.state.suraField}
                  onUpdateInput={this.handleSuraChange}
                />
              </div>
            </div>
            <div className="aya-selector__aya-box">
              <div className="aya-selector__aya-caption">آیه‌ی</div>
              <div className="aya-selector__aya">
                <TextField
                  type="number"
                  style={ayaFieldStyles}
                  name={this.props.title}
                  value={this.state.ayaField}
                  onChange={this.handleAyaChange}
                />
              </div>
            </div>
          </Paper>
        </div>
    );
  }
}

export default AyaSelector;



// WEBPACK FOOTER //
// ./src/components/AyaSelector/AyaSelector.jsx